module.exports = __webpack_public_path__ + "img/teamImg2.6d008e05.jpg";